// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bfsg-declaration {
  padding: 1rem;
  line-height: 1.6;
  font-size: 15px;
  color: #333;
  --color-p-span: black;
}
.bfsg-declaration h1 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #222;
}
.bfsg-declaration h2 {
  font-size: 18px;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  color: #444;
}
.bfsg-declaration p {
  margin-bottom: 1rem;
}
.bfsg-declaration ul {
  padding-left: 1.25rem;
  margin-bottom: 1rem;
}
.bfsg-declaration ul li {
  list-style: disc;
  margin-bottom: 0.5rem;
}
.bfsg-declaration a {
  color: #0078d7;
  text-decoration: underline;
}
.bfsg-declaration a:hover {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/accessibility-statement/accessibility-statement.page.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AACF;AAEC;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AAAF;AAGC;EACC,mBAAA;AADF;AAIC;EACC,qBAAA;EACA,mBAAA;AAFF;AAIE;EACC,gBAAA;EACA,qBAAA;AAFH;AAMC;EACC,cAAA;EACA,0BAAA;AAJF;AAME;EACC,qBAAA;AAJH","sourcesContent":[".bfsg-declaration {\n\tpadding: 1rem;\n\tline-height: 1.6;\n\tfont-size: 15px;\n\tcolor: #333;\n\t--color-p-span: black;\n\n\th1 {\n\t\tfont-size: 24px;\n\t\tfont-weight: 700;\n\t\tmargin-bottom: 1rem;\n\t\tcolor: #222;\n\t}\n\n\th2 {\n\t\tfont-size: 18px;\n\t\tfont-weight: 600;\n\t\tmargin-top: 1.5rem;\n\t\tmargin-bottom: 0.5rem;\n\t\tcolor: #444;\n\t}\n\n\tp {\n\t\tmargin-bottom: 1rem;\n\t}\n\n\tul {\n\t\tpadding-left: 1.25rem;\n\t\tmargin-bottom: 1rem;\n\n\t\tli {\n\t\t\tlist-style: disc;\n\t\t\tmargin-bottom: 0.5rem;\n\t\t}\n\t}\n\n\ta {\n\t\tcolor: #0078d7;\n\t\ttext-decoration: underline;\n\n\t\t&:hover {\n\t\t\ttext-decoration: none;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
